import { fbt } from 'fbtee'
import { Vibrate } from 'lucide-react'
import { toast } from 'sonner'
import { SettingsRow } from '../../components/SettingsCard'
import { Switch } from '../../components/ui/switch'
import { useShakeToReportEnabled } from '../../hooks/useShakeGesture'
import { requestMotionPermission, setShakeToReportEnabled } from '../../lib/shakeToReport'
import { track } from '../../lib/analytics'

export function ShakeToReportSettingsRow() {
  const enabled = useShakeToReportEnabled()

  async function toggle(next: boolean) {
    // Requested here, inside the tap, because iOS only shows the prompt from a gesture.
    if (next && (await requestMotionPermission()) !== 'granted') {
      toast.error(
        fbt(
          'Motion access is off for Faro',
          'Toast when the user enables shake to report but the browser denied motion sensor access',
        ),
      )
      return
    }
    setShakeToReportEnabled(next)
    track('shake_to_report_toggled', { enabled: next })
  }

  return (
    <SettingsRow
      icon={<Vibrate className="size-4" />}
      label={
        <label htmlFor="settings-shake-to-report">
          {fbt('Shake to report a bug', 'Label for the Settings toggle that opens the bug report form when the phone is shaken')}
        </label>
      }
      description={fbt(
        'Shake your phone to send a bug report with a screenshot.',
        'Description under the shake to report toggle in Settings',
      )}
      trailing={<Switch id="settings-shake-to-report" className="cursor-pointer" checked={enabled} onCheckedChange={next => void toggle(next)} />}
    />
  )
}
